export default __webpack_public_path__ + "static/media/sold-out-kat.a2d9d93c.svg";